import { Component, HostListener, OnInit } from "@angular/core";
import { ThemeOptions } from "../../../theme-options";
import { select } from "@angular-redux/store";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { APP_SETTINGS } from "src/environments/environment";
import { Security } from "src/app/utils/security.util";
import { PodeAcessarViewModel } from "src/app/pages/domain/viewmodels.models";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public extraParameter: any;
  public tipoInstalacao = "";
  public nivelUsuarioLogado = 0;
  podeAcessar: PodeAcessarViewModel = Security.getPodeAcessar();
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  constructor(
    public globals: ThemeOptions,
    private activatedRoute: ActivatedRoute
  ) {
    this.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
  }

  @select("config") public config$: Observable<any>;

  private newInnerWidth: number;
  private innerWidth: number;
  activeId = "homeMenu";

  toggleSidebar() {
    this.globals.toggleSidebar = !this.globals.toggleSidebar;
  }

  sidebarHover() {
    this.globals.sidebarHover = !this.globals.sidebarHover;
  }

  ngOnInit() {
    this.nivelUsuarioLogado = Security.getUser().nivel;

    setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 1200) {
        this.globals.toggleSidebar = true;
      }
    });

    this.extraParameter =
      this.activatedRoute.snapshot.firstChild.data.extraParameter;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;

    if (this.newInnerWidth < 1200) {
      this.globals.toggleSidebar = true;
    } else {
      this.globals.toggleSidebar = false;
    }
  }
}
